import components from "./components";
import classes from "./classes";
import files from "./files";
import readable from "./readable";
import helper from "./helper";
import ajax from "./ajax";
import icon from "./icon";

// From backend
//import translate from "@/octolo/user/libs/translate.js";
//import config from "@/octolo/user/libs/config.js";
//import group from "@/octolo/group/lib.js";
import user from "@/octolo/user/libs/user.js";
//import tenant from "@/octolo/user/libs/tenant.js";

export default {
    mixins: [
        classes,
        files,
        readable,
        helper,
        ajax,
        icon,
        // From backend
        //translate,
        //config,
        //group,
        user,
        //tenant,
    ],
    emits: ["component-notexist", "ready"],
    components: components,
    methods: {
        componentExist(comp){
            return (comp in this.$options.components);
        },
    }
}
